import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getJob } from "./jobApi";

const initialState = {
  jobOnEdit: {},
};

export const fetchJob = createAsyncThunk("job/fetchjob", async (id) => {
  const response = await getJob(id);
  return response;
});

const jobSlice = createSlice({
  name: "job",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchJob.fulfilled, (state, action) => {
      state.jobOnEdit = action.payload;
    });
  },
});

export default jobSlice.reducer;
